var juuls = juuls || {};
juuls.cc  = {
    init: function () {
        if ( jQuery( '.js-datatable' ).length === 1 ) {
            e4.require.js( e4.settings.require.dataTables, function () {
                juuls.cc.dataTables.bindDateFilter();
                juuls.cc.dataTables.init();
            } );
        }
        juuls.cc.bindEvents();
        juuls.cc.addresses.init();
        juuls.cc.userDiscounts.init();
        juuls.cc.deals.init();
        juuls.cc.bonusList.init();
    },
    bindEvents: function () {
        jQuery( '.js-e-orders-add-all-to-cart' ).on( 'click', function () {
            jQuery( '.js-e-orders-form' ).trigger( 'submit' );
        } );
        jQuery( '.js-juuls-cc-download-order' ).on( 'click', function () {
            window.open( location.href + '&GetPDF=true' );
        } );
    },
    xhr: function ( objData, strMethod ) {
        return jQuery.ajax( {
            method: strMethod || 'GET',
            url: location.href,
            data: objData
        } );
    },
    bonusList: {
        init: function () {
            if ( jQuery( '.js-juuls-deals-bonuses-form' ).length === 1 ) {
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-bonus-list' );
                    e4.handlebars.registerHelpers( 'compare counter' );
                    Handlebars.registerHelper( 'isLastValidRow', function ( row, rows, index, options ) {
                        var nextRow = rows[ index + 1 ];
                        if ( ( index + 1 ) === rows.length ) {
                            return row.isValid ? options.fn( this ) : options.inverse( this );
                        }
                        else {
                            return index > 0 && row.isValid && nextRow !== undefined && nextRow.isValid === false ? options.fn( this ) : options.inverse( this );
                        }
                    } );
                    juuls.cc.bonusList.bindEvents();
                    juuls.cc.bonusList.getData();
                } );
            }
        },
        bindEvents: function () {
            jQuery( '.js-juuls-bonus-list-container' )
                    .on( 'click', '.js-juuls-delete-bonus', function ( event ) {
                        var jRow = jQuery( event.target ).closest( '.js-juuls-bonus-row' );
                        jRow.find( 'input' ).each( function ( index, domInput ) {
                            domInput.value           = 0;
                            domInput.dataset.ruleMin = 0;
                        } );
                        juuls.cc.bonusList.setData();
                    } )
                    .on( 'input', 'input', e4.util.debounce( function ( event ) {
                        return juuls.cc.bonusList.validateRow( event.target );
                    }, e4.settings.debounceDelay.input * 2 ) );
        },
        validateRow: function ( domElm ) {
            var jRow             = jQuery( domElm ).closest( '.js-juuls-bonus-row' ),
                jFromInput       = jRow.find( '.js-juuls-bonus-from-input' ),
                jToInput         = jRow.find( '.js-juuls-bonus-to-input' ),
                jPercentageInput = jRow.find( '.js-juuls-bonus-percentage-input' ),
                jForm            = jQuery( '.js-juuls-deals-bonuses-form' );
            if ( jFromInput.is( '.js-juuls-bonus-first-from-input' ) === false ) {
                if ( parseInt( jToInput.val() ) > 0 && parseInt( jFromInput.val() ) === 0 ) {
                    jFromInput.val( jFromInput.data( 'fromValue' ) );
                    jToInput.data( 'ruleMin', jFromInput.data( 'fromValue' ) );
                }
                if ( parseInt( jToInput.val() ) > 0 && parseInt( jFromInput.val() ) > 0 && parseFloat( e4.util.formatStringToJavascriptNumber( jPercentageInput.val() ).toString() ) > 0 && jForm.valid() ) {
                    juuls.cc.bonusList.setData();
                }
            }
            else {
                if ( parseInt( jToInput.val() ) > 0 ) {
                    jToInput.data( 'ruleMin', parseInt( jFromInput.val() ) + 1 );
                }
                if ( parseInt( jToInput.val() ) > 0 && parseFloat( e4.util.formatStringToJavascriptNumber( jPercentageInput.val() ).toString() ) > 0 ) {
                    juuls.cc.bonusList.setData();
                }
            }
        },
        setData: function () {
            var jForm = jQuery( '.js-juuls-deals-bonuses-form' );
            if ( jForm.valid() ) {
                jQuery( '.js-juuls-bonus-loader' ).removeClass( 'is-loading' );
                juuls.cc.xhr( jForm.serialize(), 'POST' ).done( function () {
                    juuls.cc.bonusList.getData();
                } );
            }
        },
        getData: function () {
            jQuery.ajax( {
                url: '/system/data/bonus',
                method: 'GET',
                dataType: 'JSON'
            } ).done( function ( json ) {
                var result  = {
                        rows: []
                    },
                    prevKey = '';
                jQuery.each( json.rows, function ( key, entry ) {
                    if ( key !== 'BonusStep0' ) {
                        entry.key       = key;
                        entry.isValid   = entry.ToAmount > 0 && entry.Percentage > 0;
                        entry.isVisible = entry.isValid;
                        if ( prevKey !== '' && prevKey !== undefined ) {
                            var prevRow     = json.rows[ prevKey ];
                            entry.isVisible = prevRow.isValid;
                        }
                        else {
                            entry.isVisible = true;
                        }
                        result.rows.push( entry );
                        prevKey = key;
                    }
                } );
                juuls.cc.bonusList.build( result );
            } )
        },
        build: function ( data ) {
            jQuery( '.js-juuls-bonus-list-container' ).html( e4.handlebars.tmpl.bonusList( data ) );
            jQuery( '.js-juuls-bonus-loader' ).removeClass( 'is-loading' );
        }
    },
    addresses: {
        init: function () {
            juuls.cc.addresses.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-juuls-cc-default-address' ).on( 'click', function ( event ) {
                juuls.cc.addresses.makeDefaultAddress( event.currentTarget.dataset.id );
            } );
            jQuery( '.js-juuls-cc-delete-address' ).on( 'click', function ( event ) {
                juuls.cc.addresses.delete( event.currentTarget.dataset.id );
            } );
            jQuery( '.js-juuls-cc-update-address' ).on( 'click', function ( event ) {
                juuls.cc.addresses.update( event.currentTarget.dataset.id );
            } );
            jQuery( '.js-juuls-cc-add-address' ).on( 'click', function () {
                juuls.cc.addresses.add();
            } );
        },
        xhr: function ( jForm ) {
            return jQuery.ajax( {
                url: jForm.attr( 'action' ),
                data: jForm.serialize()
            } );
        },
        makeDefaultAddress: function ( addressId ) {
            var jForm                                                    = jQuery( '#UserManagementManageAddressesForm' );
            document.getElementById( 'SelectedAddressId' ).value         = addressId;
            document.getElementById( 'ManageAddressesFormAction' ).value = 'MakeDefault';
            juuls.cc.addresses.xhr( jForm ).done( function () {
                location.reload();
            } );
        },
        delete: function ( addressId ) {
            var jForm = jQuery( '#UserManagementManageAddressesForm' );
            if ( document.getElementById( 'UserId' ).value === addressId ) {
                juuls.ui.confirm( {
                    header: 'Main address can not be deleted'
                } );
            }
            else if ( document.getElementById( 'DefaultAddressId' ).value === addressId ) {
                juuls.ui.confirm( {
                    header: 'You can’t delete a default address. Set another address as default before delete this address.'
                } );
            }
            else {
                juuls.ui.confirm( {
                    header: 'Delete address?',
                    type: 'confirm'
                }, function ( addressId ) {
                    document.getElementById( 'SelectedAddressId' ).value         = addressId;
                    document.getElementById( 'ManageAddressesFormAction' ).value = 'Delete';
                    juuls.cc.addresses.xhr( jForm ).done( function () {
                        location.reload();
                    } );
                }, [ addressId ] );
            }
        },
        add: function () {
            var jForm                                                    = jQuery( '#UserManagementManageAddressesForm' );
            document.getElementById( 'ManageAddressesFormAction' ).value = 'Add';
            jForm.submit();
        },
        update: function ( addressId ) {
            var jForm                                                    = jQuery( '#UserManagementManageAddressesForm' );
            document.getElementById( 'SelectedAddressId' ).value         = addressId;
            document.getElementById( 'ManageAddressesFormAction' ).value = 'Update';
            jForm.submit();
        }
    },
    userDiscounts: {
        init: function () {
            juuls.cc.userDiscounts.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-juuls-toggle-user-discount-input' ).on( 'change', function ( event ) {
                juuls.cc.userDiscounts.setActive( event.target.value );
            } );
            jQuery( '.js-juuls-deals-user-discounts-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
                var jForm = jQuery( event.target );
                if ( jForm.valid() ) {
                    juuls.cc.userDiscounts.update( jForm );
                }
            } );
        },
        setActive: function ( strDiscountType ) {
            var arrClearJRows  = [],
                jXyRow         = jQuery( '.js-juuls-user-discount-row-xy' ),
                jPercentageRow = jQuery( '.js-juuls-user-discount-row-percentage' );
            if ( strDiscountType === 'xy' ) {
                //XY
                jPercentageRow.addClass( 'd-none' );
                jXyRow.removeClass( 'd-none' );
                arrClearJRows.push( jPercentageRow );
            }
            else if ( strDiscountType === 'percentage' ) {
                //PCT
                jPercentageRow.removeClass( 'd-none' );
                jXyRow.addClass( 'd-none' );
                arrClearJRows.push( jXyRow );
            }
            else {
                jPercentageRow.addClass( 'd-none' );
                jXyRow.addClass( 'd-none' );
                arrClearJRows.push( jXyRow );
                arrClearJRows.push( jPercentageRow );
            }
            juuls.cc.userDiscounts.clearInactive( arrClearJRows );
        },
        clearInactive: function ( arrClearJRows ) {
            for ( var i = 0; i < arrClearJRows.length; i++ ) {
                arrClearJRows[ i ].find( 'input' ).val( 0 );
            }
        },
        update: function ( jForm ) {
            juuls.cc.xhr( jForm.serialize(), 'POST' ).done( function () {
                juuls.cc.xhr().done( function ( html ) {
                    var jHtml              = jQuery( html ),
                        updatedFormContent = jHtml.find( '.js-juuls-deals-user-discounts-form' ).html();
                    jForm.html( updatedFormContent );
                } );
            } );
        }
    },
    deals: {
        init: function () {
            juuls.cc.deals.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-juuls-deals-create' ).on( 'click', function ( event ) {
                juuls.cc.deals.create.setType( event.currentTarget.dataset.type );
                juuls.cc.deals.create.show();
            } );
            jQuery( '.js-juuls-create-deal-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
                var jForm = jQuery( event.target );
                if ( jForm.valid() ) {
                    juuls.cc.deals.create.post( jForm );
                }
            } ).on( 'click', '.js-juuls-delete-deal', function ( event ) {
                event.preventDefault();
                var objData = jQuery( event.currentTarget ).data();
                juuls.ui.confirm( {
                    header: 'Slet rabat aftale?',
                    text: 'Er du sikker på du vil slette rabatten ' + objData.discountId + ' for brugeren ' + objData.discountUser + '?',
                    type: 'confirm'
                }, juuls.cc.deals.delete, [ objData ] );
            } ).on( 'click', '.js-juuls-cancel-deal', function ( event ) {
                event.preventDefault();
                juuls.cc.deals.create.hide();
            } );
            e4.require.js( e4.settings.require.typeahead, function () {
                juuls.cc.deals.create.productPicker.init();
            } );
        },
        create: {
            type: '',
            setType: function ( strType ) {
                juuls.cc.deals.create.type = strType;
                jQuery( '.js-juuls-create-deal-form' ).find( 'input[name="action"]' ).val( strType );
            },
            show: function () {
                jQuery( '.js-juuls-add-deal-row' ).addClass( 'd-none' );
                jQuery( '.js-juuls-add-deal-row.juuls-add-deal-' + juuls.cc.deals.create.type ).removeClass( 'd-none' ).addClass('pending');
            },
            hide: function () {
                jQuery( '.js-juuls-add-deal-row' ).addClass( 'd-none' ).removeClass('pending');
                juuls.cc.deals.create.setType( '' );
            },
            post: function ( jForm ) {
                jQuery.ajax({
                    method:'POST',
                    url: '/system/data/deals',
                    data:jForm.serialize(),

                }).always( function () {
                    location.reload();
                } );
            },
            productPicker: {
                init: function () {
                    jQuery( '.js-juuls-productpicker' ).each( function ( index, domInput ) {
                        var jInput = jQuery( domInput );
                        jInput.typeahead( {
                            hint: true,
                            highlight: true,
                            minLength: 3,
                            classNames: {
                                menu: 'dropdown-menu juuls-typeahead-menu w-100',
                                suggestion: 'dropdown-item',
                                open: 'open',
                                cursor: 'active cursor-pointer',
                                highlight: 'active'
                            }
                        }, {
                            name: 'juuls',
                            display: function ( suggestion ) {
                                return suggestion.number + ' - ' + suggestion.name;
                            },
                            limit: 8,
                            async: true,
                            source: function ( query, syncResults, asyncResults ) {
                                juuls.cc.deals.create.productPicker.getProductSuggestions( query, function ( data ) {
                                    asyncResults( data.products );
                                } );
                            }
                        } ).on( 'typeahead:autocomplete typeahead:select', function ( event, product ) {
                            if ( product !== null ) {
                                jInput.typeahead( 'val', product.id ).trigger( 'blur' );
                                jQuery( this ).typeahead( 'close' );
                            }
                        } );
                    } );
                },
                getProductSuggestions: function ( query, asyncResults ) {
                    if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
                        this.jqXHR.abort();
                    }

                    query = jQuery.trim( query );
                    if ( query !== '' ) {
                        this.jqXHR = jQuery.ajax( {
                            method: 'GET',
                            url: e4.settings.search.result.products.url + encodeURIComponent( jQuery.trim( query ) ) + '&pagesize=' + e4.settings.search.result.products.pagesize,
                            dataType: 'json'
                        } );
                        this.jqXHR.done( function ( data ) {
                            asyncResults( data );
                        } );
                    }
                },
            }
        },
        delete: function ( objData ) {

            jQuery.ajax({
                method:'POST',
                url: '/system/data/deals',
                data:{
                    action: 'deleteDiscount',
                    discountId: objData.discountId
                }

            }).always( function () {
                location.reload();
            } );

        }
    },
    downloadPdf: function ( dtDocId ) {
        location.href = '/?GetPDF=true&docNo=' + dtDocId + '&doctype=' + juuls.cc.getOrderRequestType();
    },
    getOrderRequestType: function () {
        return jQuery( '.js-juuls-order-type' ).filter(':checked').val();
    },
    dataTables: {
        endpoint: '/system/data/orders?type=',
        instance: null,
        init: function () {
            var arrColumnLayout  = [
                    { data: 'id' },
                    {
                        data: 'OrderDate',
                        render: function ( data, type ) {
                            if ( type === 'display' ) {
                                return juuls.cc.dataTables.formatDate( new Date( data ) )
                            }
                            if ( type === 'sort' ) {
                                return new Date( data )
                            }
                            return data;
                        }
                    },
                    {
                        data: 'ShipDate',
                        render: function ( data, type ) {
                            if ( type === 'display' ) {
                                return juuls.cc.dataTables.formatDate( new Date( data ) )
                            }
                            if ( type === 'sort' ) {
                                return new Date( data )
                            }
                            return data;
                        }
                    },
                    {
                        data: 'totalAmount',
                        render: function ( data, type ) {
                            if ( type === 'display' ) {
                                return juuls.cc.dataTables.formatPrice( data );
                            }
                            if ( type === 'sort' ) {
                                return e4.util.formatStringToJavascriptNumber( data );
                            }
                            return data;
                        }
                    },
                    {
                        data: 'Status'
                    },
                    {
                        className: 'customer-actions',
                        defaultContent: '<button class="btn btn-sm btn-secondary mr-1 js-juuls-cc-list-download-order"><i class="material-icons m-0">file_download</i></button><button class="btn btn-sm btn-primary js-juuls-cc-view-order"><i class="material-icons m-0">arrow_forward_ios</i></button>',
                        orderable: false,
                        searchable: false
                    }
                ],
                objTranslations  = jQuery( '.js-datatable' ).data(),
                dataTableOptions = {
                    ajax: {
                        url: juuls.cc.dataTables.endpoint + juuls.cc.getOrderRequestType(),
                        dataSrc: 'orders'
                    },
                    language: {
                        lengthMenu: objTranslations.translationLength,
                        info: objTranslations.translationInfo,
                        paginate: {
                            next: objTranslations.translationPagingNext,
                            last: objTranslations.translationPagingLast,
                            first: objTranslations.translationPagingFirst,
                            previous: objTranslations.translationPagingPrevious
                        },
                        search: objTranslations.translationSearch
                    },
                    rowId: 'id',
                    columns: arrColumnLayout,
                    ordering: true,
                    select: true,
                    order: [
                        [
                            1,
                            'desc'
                        ]
                    ],
                    dom: '<"datatables-top d-flex small justify-content-between align-items-end"<"orders-datatable_date">f>rt<"datatables-bottom small d-flex justify-content-between"lip>',
                    initComplete: function ( settings, json ) {
                        if ( json !== undefined ) {
                            juuls.cc.dataTables.json = json;
                        }
                        juuls.cc.dataTables.bindEvents( settings.oInstance[0] );
                        juuls.cc.dataTables.appendDateFilter();
                        jQuery( '.js-e-datatable-loading-overlay' ).removeClass( 'is-loading' );
                    }
                };
            juuls.cc.dataTables.instance = jQuery( '#orders-datatable' ).DataTable( dataTableOptions );
        },
        bindEvents: function ( domInstance ) {
            jQuery( domInstance )
                    .on( 'click', '.js-juuls-cc-list-download-order', function ( event ) {
                        var dtDocId = juuls.cc.dataTables.getDocId( event.target );
                        juuls.cc.downloadPdf( dtDocId );
                    } )
                    .on( 'click', '.js-juuls-cc-view-order', function ( event ) {
                        var dtRowId = juuls.cc.dataTables.getDocId( event.target );
                        juuls.cc.dataTables.gotoDetails( dtRowId );
                    } );
            jQuery( '.js-juuls-order-date-from, .js-juuls-order-date-to' ).on( 'change', function () {
                juuls.cc.dataTables.instance.draw();
            } );
            jQuery( '.js-juuls-order-type' ).on( 'change', function () {
                juuls.cc.dataTables.instance.ajax.url( juuls.cc.dataTables.endpoint + juuls.cc.getOrderRequestType() ).load();
            } );
        },
        bindDateFilter: function () {
            jQuery.fn.dataTable.ext.search.push( function ( settings, data ) {
                var jFromDateInput = jQuery( '.js-juuls-order-date-from' ),
                    jToDateInput   = jQuery( '.js-juuls-order-date-to' ),
                    minDate        = jFromDateInput.val() ? new Date( jFromDateInput.val() ) : null,
                    maxDate        = jToDateInput.val() ? new Date( jToDateInput.val() ) : null,
                    entryDate      = new Date( data[ 1 ] );
                if ( ( minDate === null && maxDate === null ) || ( minDate === null && entryDate <= maxDate ) || ( minDate <= entryDate && maxDate === null ) || ( minDate <= entryDate && entryDate <= maxDate ) ) {
                    return true;
                }
            } );
        },
        appendDateFilter: function () {
            var dateFilters = jQuery( '.js-juuls-dt-date-filters' );
            dateFilters.detach().appendTo( '.orders-datatable_date' );
            jQuery( '.orders-datatable_date' ).find( '.js-juuls-dt-date-filters' ).removeAttr( 'hidden' );
        },
        formatDate: function ( strDate ) {

            /*var month = strDate.getDay() > 9 ? strDate.getDay() : '0' + strDate.getDay(),
             day   = strDate.getDate() > 9 ? strDate.getDate() : '0' + strDate.getDate(),
             year  = strDate.getFullYear(),*/
            var month = (''+(strDate.getMonth()+1)).length === 1 ? '0'+(strDate.getMonth()+1) : (strDate.getMonth()+1),
                day   = (''+strDate.getDate()).length === 1 ? '0'+strDate.getDate() : strDate.getDate(),
                year  = strDate.getFullYear(),
                returnValue = [
                    day,
                    month,
                    year
                ].join( '/' );
            return returnValue;

        },
        formatPrice: function(numberString){
            const number = parseFloat(numberString.replace(/,/g, ''));
            const price = new Intl.NumberFormat('da-DK', {
                style: 'currency',
                currency: 'DKK'
            }).format(number);
            return price;
        },
        getDocId: function ( domElm ) {
            var dtRow = domElm.closest( 'tr' );
            if ( dtRow ) {
                return dtRow.id;
            }
            else {
                return domElm.dataset.docId;
            }
        },
        gotoDetails: function ( dtDocId ) {
            location.href = location.pathname + '/order?docno=' + dtDocId + '&doctype=' + juuls.cc.getOrderRequestType();
        }
    }
}
